import React from 'react';
import { Site } from '../../lib/Site';

interface Props {
    site: Site;
    focused: boolean;
}

export default function FocusedNavigation({ site, focused }: Props) {
    if (!focused) return null;

    return (
        <div className="site-header__item site-header__item--focused-navigation">
            <div className="top-level-nav">
                <div className="top-level-nav__item top-level-nav__item--first">
                    <span className="icon icon--phone-1 icon--offset-right icon--inline" />
                    {site.get('phone.support')}
                </div>
            </div>
        </div>
    );
}
